export function cleanString(str) {
    return str
        .replace(/ /g, " ")
        .replace(/\s+|:\s*$/g, " ")
        .trim();
}
